<div class="tab-container">
  <div class="tab-highlight" [style.left]="getSelectorPosition()" [style.width]="getTabWidth()"></div>
  @for( tab of tabs(); track tab; let i = $index) {
  <div class="tab" [class.active]="selectedIndex() === i" (click)="selectTab(i)">
    {{ tab }}
  </div>
  }
</div>
